import { useGetSessionSchemaQuery } from "../../../../services/submissionPeriod/api";
import SessionAlert from "./Session/Alert";

function CreateAlertModal({ Modal, session, type: _type }) {
  const type = _type || session?.type
  const {
    data = {},
    isLoading,
    isSuccess,
  } = useGetSessionSchemaQuery({
    type,
  });
  const sessionWithSchema = {
    ...data,
    ...session,
  };
  if (!isLoading) {
    return false;
  }
  if (!isSuccess) {
    return false;
  }

  return (
    <SessionAlert
      isDraft
      action={
        <Modal
          sx={{
            alignSelf: "center",
          }}
          color="inherit"
          session={sessionWithSchema}
        >
          Create
        </Modal>
      }
    />
  );
}

export default CreateAlertModal;
